module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-15.f04fe800.png";